import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { ApiService } from "../services";

export function useLoginUserMutation() {
  const queryClient = useQueryClient();
  const { user, order } = useSelector((state) => ({
    user: state.user,
    order: state.order
  }));

  return useMutation({
    mutationKey: ["login/mobile"],
    mutationFn: async (otp) => {
      const response = await ApiService.post("auth/login/mobile", {
        phoneNumber: user.details.phoneNumber,
        otp
      });
      if (!response.token)
        throw Error("Invalid request, not able to generate token!");

      return response;
    },
    onSuccess: (data) => {
      if (
        !data.user.meta?.shopify?.[order.shopDomain] ||
        data.user.meta?.shopify?.[order.shopDomain]?.shopifyId ===
          user.shopifyDetails.shopifyId
      ) {
        queryClient.invalidateQueries(["sync-user", data.token]);
      }
    }
  });
}

export function useSendOtpMutation(user) {
  return useMutation({
    mutationKey: ["generate-otp"],
    mutationFn: async () => {
      const response = await ApiService.post("auth/generate-otp", {
        phoneNumber: user.details.phoneNumber,
        subscribe: user.subscribe,
        waOptin: user.subscribe
      });
      return response;
    }
  });
}

export function useReSendOtpMutation(user) {
  return useMutation({
    mutationKey: ["resend-otp"],
    mutationFn: async () => {
      const response = await ApiService.post("auth/resend-otp", {
        phoneNumber: user.details.phoneNumber
      });
      return response;
    }
  });
}
